import { Box, Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';

import { StandardCost } from 'bom/elements';
import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { Price } from 'core/elements';
import { getAgGridTableCellData } from 'core/utils';
import { QuotePartColId } from 'quotes/components/QuotePartList';

export const CostCell = (props: ICellRendererParams) => {
  const data = getAgGridTableCellData(props, QuotePartColId.COST);

  if (!data) {
    return props?.value;
  }

  const { cost, purchaseCost } = data;

  if (!purchaseCost) {
    return <Box sx={{ textAlign: 'right' }}>{DEFAULT_PLACEHOLDER}</Box>;
  }

  return (
    <Stack>
      <StandardCost cost={cost} label={`${t('labelStandardCost')}:`} />

      <Price amount={purchaseCost} label={`${t('labelCost')}:`} />
    </Stack>
  );
};
